module.exports = __webpack_public_path__ + "static/media/not_login_events.8642ef45.png";